import { Link } from "react-router-dom";
import SiteLayout from "@/components/feature/SiteLayout";
import SectionHeader from "@/components/feature/SectionHeader";
import VideoCard from "@/components/feature/VideoCard";
import HeroCarousel from "@/pages/home/components/HeroCarousel";
import CategoryEntry from "@/pages/home/components/CategoryEntry";
import { videos } from "@/mocks/videos";
import { sortVideos } from "@/utils/video";

const stats = [
  { label: "在库影视", value: "12,800+" },
  { label: "覆盖分类", value: "30+" },
  { label: "每日更新", value: "200+" },
  { label: "高清资源", value: "4K / HD" },
];

export default function Home() {
  const hotList = sortVideos(videos, "popular").slice(0, 20);
  const latestList = sortVideos(videos, "recent").slice(0, 12);

  return (
    <SiteLayout>
      <HeroCarousel />

      <section className="mx-auto max-w-[1400px] px-4 pt-8 md:px-6 md:pt-10">
        <div className="rounded-lg border border-background-200 bg-background-100 p-5 md:p-7">
          <div className="flex flex-col gap-5 lg:flex-row lg:items-center lg:justify-between">
            <div className="max-w-2xl">
              <h1 className="font-heading text-xl font-black text-foreground-950 md:text-3xl">
                91看片 · 优质影视资源在线观看平台
              </h1>
              <p className="mt-3 text-sm leading-relaxed text-foreground-600">
                91看片汇集电影、电视剧、综艺节目的丰富内容与分类资料，支持按类型、地区、年份、标签等多条件筛选与排序，
                并提供影视名称与主演关键词搜索，帮助你快速发现想看的内容。本站为影视信息导航与浏览平台，不提供视频存储与付费服务。
              </p>
            </div>
            <div className="grid grid-cols-2 gap-4 sm:grid-cols-4 lg:gap-6">
              {stats.map((item) => (
                <div key={item.label} className="min-w-[80px]">
                  <p className="font-heading text-lg font-black text-primary-600 md:text-2xl">{item.value}</p>
                  <p className="mt-1 whitespace-nowrap text-xs text-foreground-500">{item.label}</p>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

      <div className="mt-8 md:mt-10">
        <CategoryEntry />
      </div>

      <section className="mx-auto mt-12 max-w-[1400px] px-4 md:mt-14 md:px-6">
        <SectionHeader
          title="热门影视推荐"
          subtitle="根据热度与口碑综合排序的精选片单"
          actionLabel="查看全部"
          actionTo="/category/movie"
        />
        <div className="grid grid-cols-2 gap-4 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5">
          {hotList.map((item) => (
            <VideoCard key={item.id} item={item} showFavorite />
          ))}
        </div>
      </section>

      <section className="mx-auto mt-12 max-w-[1400px] px-4 md:mt-14 md:px-6">
        <SectionHeader title="最新上线" subtitle="刚刚更新的影视内容，追新不迷路" />
        <div className="no-scrollbar -mx-4 flex gap-4 overflow-x-auto px-4 pb-2 md:mx-0 md:px-0">
          {latestList.map((item) => (
            <Link
              key={item.id}
              to={`/detail/${item.id}`}
              className="group w-[150px] shrink-0 cursor-pointer md:w-[180px]"
              title={`${item.title}（${item.year}）`}
            >
              <div className="relative w-full overflow-hidden rounded-lg bg-background-200" style={{ aspectRatio: "3 / 4" }}>
                <img
                  src={item.cover}
                  alt={`${item.title}封面海报`}
                  className="h-full w-full object-top object-cover transition-transform duration-500 group-hover:scale-105"
                />
                <span className="absolute bottom-2 left-2 rounded-md bg-primary-950/80 px-1.5 py-0.5 text-[11px] font-medium text-background-50">
                  {item.updatedAt.slice(5)} 更新
                </span>
              </div>
              <h3 className="mt-2 line-clamp-1 font-heading text-sm font-semibold text-foreground-950 group-hover:text-primary-600">
                {item.title}
              </h3>
              <p className="mt-0.5 line-clamp-1 text-xs text-foreground-500">
                {item.year} · {item.genres[0]}
              </p>
            </Link>
          ))}
        </div>
      </section>
    </SiteLayout>
  );
}